import { FC, useEffect } from 'react';
import { Outlet } from 'react-router';

import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { fetchBasicData, localizationSelector } from 'store/localizationState';
import { resetSignupState } from 'store/signupState';

const SignUpPage: FC = () => {
  const { countryOptions } = useAppSelector(localizationSelector);
  const dispatch = useAppDispatch();

  // Fetch country and language options
  useEffect(() => {
    if (!countryOptions.length) {
      dispatch(fetchBasicData());
    }
  }, [dispatch, countryOptions]);

  // Reset signup state on unmount
  useEffect(() => {
    return () => {
      dispatch(resetSignupState());
    };
  }, [dispatch]);

  return <Outlet />;
};

export default SignUpPage;
